import React, { useState } from "react";
import axios from "axios";
import { useFormik } from "formik";
import * as yup from "yup";
import { Link } from "react-router-dom";
import {
  Card,
  Row,
  Col,
  Button,
  Form,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { Section } from "../../shared";

export default function EmailVerification(props) {
  const [hasSubmitted, setSubmitted] = useState(false);
  const [email, setEmail] = useState();
  const [key, setKey] = useState();
  const [verified, setVerified] = useState();
  const [showResend, setShowResend] = useState(false);

  const emailSchema = yup.object({
    email: yup
      .string()
      .email("Invalid Email Address format.")
      .required("A valid email is required."),
  });

  const verifySchema = yup.object({
    key: yup.string().required("A key is required."),
  });

  const emailForm = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: emailSchema,
    onSubmit: (values) => {
      sendEmail(values);
    },
  });

  const verifyForm = useFormik({
    initialValues: {
      key: "",
    },
    validationSchema: verifySchema,
    onSubmit: (values) => {
      checkVerification(values);
    },
  });

  const sendEmail = async (values) => {
    setEmail(values.email);
    setSubmitted(true);

    await axios
      .get(`api/v1/hwts/tempid/sendemailverification?email=${values.email}`)
      .then((res) => {
        if (res.data === 1) {
        } else if (res.data === 2) {
          setShowResend(true);
        }
      });
  };

  const checkVerification = async (values) => {
    await axios
      .get(
        `api/v1/hwts/tempid/CheckEmailVerification?email=${email}&key=${values.key}`
      )
      .then((res) => {
        setVerified(res.data);
      });
  };

  const resendEmail = async (values) => {
    await axios
      .get(`api/v1/hwts/tempid/resendemailverification?email=${email}`)
      .then((res) => {});
  };

  const renderProceedTooltip = (props) => (
    <Tooltip id="proceed-tooltip" {...props}>
      You must first verify your email before you can proceed to the
      application.
    </Tooltip>
  );

  return (
    <div className="">
      <Section title="Temporary CA ID Number Application" type={"standout"} />
      <div className="container mt-2" style={{ fontSize: "0.9em" }}>
        <div className="three-quarters" style={{ float: "none" }}>
          <Card className="tempid-card">
            <Card.Header>
              <i className="fa fa-align-justify"></i>
              <strong>Email Verification</strong>
              <div className="card-header-actions"></div>
            </Card.Header>
            <Card.Body>
              <Row className="">
                <Col xs="12">
                  All California ID Numbers require a valid email address
                  associated with the ID. In order to begin the application, you
                  must first verify your email address.
                </Col>
              </Row>
              <Form onSubmit={emailForm.handleSubmit}>
                <Row className="mt-4">
                  <Form.Group as={Col} md="12" xs="12" controlId="email">
                    <Form.Label>Email Address</Form.Label>
                    <Row>
                      <Col xs="12" md="8" style={{ marginTop: "5px" }}>
                        <Form.Control
                          id="email"
                          name="email"
                          type="text"
                          placeholder="Enter email address"
                          value={emailForm.values.email}
                          onChange={emailForm.handleChange}
                          disabled={hasSubmitted === true}
                        />
                      </Col>
                      <Col xs="12" md="4">
                        {hasSubmitted === false && (
                          <Button
                            type="submit"
                            disabled={hasSubmitted === true}
                            className="btn-block"
                            style={{
                              visibility:
                                hasSubmitted === true ? "hidden" : "visible",
                            }}
                          >
                            Submit
                          </Button>
                        )}
                      </Col>
                    </Row>

                    <Form.Text className="text-muted">
                      <i>ex: johndoe@gmail.com</i>
                    </Form.Text>
                    {emailForm.touched.email && emailForm.errors.email ? (
                      <div className="mt-2" style={{ color: "red" }}>
                        {emailForm.errors.email}
                      </div>
                    ) : null}
                    {emailForm.touched.email && showResend === true ? (
                      <div className="mt-2" style={{ color: "#03567c" }}>
                        A verification code has recently been submitted for this
                        email address. If you would like to resend the
                        verification code to this email, please hit the Resend
                        button.
                      </div>
                    ) : null}
                  </Form.Group>
                </Row>
              </Form>

              {hasSubmitted == true && (
                <Form onSubmit={verifyForm.handleSubmit}>
                  <Row>
                    <Form.Group as={Col} md="12" xs="12" controlId="email">
                      {emailForm.touched.email && showResend === false && (
                        <Row className="mb-4">
                          <Col xs="12">
                            Thank you for submitting your email address for
                            verification. An email with your verification code
                            will be sent to the email address you provided
                            shortly.
                          </Col>
                        </Row>
                      )}
                      <Form.Label>Email Verification Code</Form.Label>
                      <Row>
                        <Col xs="12" md="8" style={{ marginTop: "5px" }}>
                          <Form.Control
                            id="key"
                            name="key"
                            type="text"
                            placeholder="Enter Verification Key"
                            value={verifyForm.values.key}
                            onChange={verifyForm.handleChange}
                            disabled={verified === true}
                          />
                        </Col>
                        {verified !== true ? (
                          <Col xs="12" md="4" className="px-0 mx-0">
                            <Row className="mx-0">
                              <Col xs="12" md="6">
                                <Button
                                  type="submit"
                                  disabled={verified === true}
                                  className="btn-block"
                                  style={{
                                    visibility:
                                      verified === true ? "hidden" : "visible",
                                  }}
                                >
                                  Verify
                                </Button>
                              </Col>
                              <Col xs="12" md="6">
                                <Button
                                  type="button"
                                  variant="warning"
                                  className="btn-block"
                                  onClick={() => resendEmail()}
                                >
                                  Resend
                                </Button>
                              </Col>
                            </Row>
                          </Col>
                        ) : (
                          <span
                            className="ca-gov-icon-check-mark"
                            style={{ fontSize: "1.5em", color: "green" }}
                          />
                        )}
                      </Row>
                      {verifyForm.touched.key && verifyForm.errors.key ? (
                        <div style={{ color: "red" }}>
                          {verifyForm.errors.key}
                        </div>
                      ) : null}
                      {verified === false && (
                        <Row style={{ color: "red" }} className="mx-0">
                          <span
                            className="ca-gov-icon-close-mark"
                            style={{ fontSize: "1.5em", color: "red" }}
                          />
                          <span style={{ lineHeight: "2em" }}>
                            Incorrect code. Please try again.
                          </span>
                        </Row>
                      )}
                    </Form.Group>
                  </Row>
                </Form>
              )}
            </Card.Body>
            <Card.Footer>
              <Row className="mt-3">
                <Col xs="6" className="text-center">
                  <Link to="/tempid">
                    <Button
                      size="lg"
                      style={{
                        width: "200px",
                        backgroundColor: "lightgrey",
                        borderColor: "darkgrey",
                        color: "black",
                      }}
                    >
                      Cancel
                    </Button>
                  </Link>
                </Col>
                <Col xs="6" className="text-center">
                  <OverlayTrigger
                    placement="top"
                    overlay={renderProceedTooltip}
                    trigger={["hover", "click"]}
                    show={verified === true ? false : undefined}
                  >
                    <span className="d-inline-block">
                      <Link
                        to={`/tempidapplication?email=${email}`}
                        style={{
                          pointerEvents: verified !== true ? "none" : null,
                        }}
                      >
                        <Button
                          variant="success"
                          size="lg"
                          style={{
                            width: "200px",
                            pointerEvents: verified !== true ? "none" : null,
                          }}
                          disabled={verified !== true}
                        >
                          Proceed
                        </Button>
                      </Link>
                    </span>
                  </OverlayTrigger>
                </Col>
              </Row>
            </Card.Footer>
          </Card>
        </div>
      </div>
    </div>
  );
}
